module.exports = __webpack_public_path__ + "static/media/btg-logo.c908c066.svg";